<template>
    <!-- <nav class="layout_nav"> -->
    <div class="nav_btn" @click="changeSideMenu">
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
    </div>
    <div class="layout_top_gnb">
        <div class="admin_info" @click="isActive = !isActive">
            <i class="admin_user_face"></i>
            <p>{{ adminId }}</p>
        </div>
        <div :class="`admin_infobox ${isActive == true ? 'active' : ''}`">
            <router-link to="/admin" v-if="role == 1" @click="isActive = false">관리자정보</router-link>
            <router-link to="/login" @click="isActive = false">로그아웃</router-link>
        </div>
    </div>
    <!-- </nav> -->
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
const store = useStore();
const isSideMenu = computed(() => store.state.menuList.isSideMenu);
const isActive = ref(false);
const adminId = localStorage.getItem("admin_id");
const role = localStorage.getItem("role");
const changeSideMenu = () => {
    store.commit("menuList/setSideMenu", !isSideMenu.value);
};
</script>

<style scoped></style>